'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parcelArchiveComponent = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parcelArchiveComponent = exports.parcelArchiveComponent = {
    template: require('./parcel-archive.html'),
    controllerAs: 'vm',
    bindings: {
        parcels: '<'
    },
    controller: ["$scope", "$state", "$stateParams", "common", "gettextCatalog", "Paging", "parcelService", "Analytics", function parcelArchiveController($scope, $state, $stateParams, common, gettextCatalog, Paging, parcelService, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.search = search;
        vm.clear = clear;
        vm.goToPage = goToPage;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.isSearchUsed = isSearchUsed;
        vm.pageCountList = [12, 24, 36];
        vm.model = null;
        vm.ordersLoading = false;
        vm.dateFormat = 'YYYY-MM-DD';
        vm.paging = Paging.create({
            page: 1,
            itemsPerPage: parseInt($stateParams.pageSize) || vm.pageCountList[0],
            totalItems: 0
        });

        function init() {
            var pageTitle = gettextCatalog.getString('parcel.allMyParcels');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/parcels/parcel-archive', pageTitle);

            loadData(vm.paging.itemsPerPage).then(function () {
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                loadData(vm.paging.itemsPerPage);
            });
        }

        function loadData(itemsPerPage) {
            vm.ordersLoading = true;

            var params = getQueryStringParams(itemsPerPage);

            return parcelService.search(params).then(function (response) {
                vm.model = response;
                vm.paging = Paging.create({
                    page: params.page,
                    itemsPerPage: vm.paging.itemsPerPage,
                    totalItems: response.count
                });
                vm.ordersLoading = false;
            });
        }

        function getQueryStringParams(itemsPerPage) {
            var page = parseInt($stateParams.page);

            return {
                page: page,
                skip: vm.paging.getSkipValue(page, itemsPerPage),
                take: itemsPerPage,
                identification: $stateParams.identification,
                orderNumber: $stateParams.orderNumber,
                barCode: $stateParams.barCode,
                dateFrom: $stateParams.dateFrom,
                dateTo: $stateParams.dateTo
            };
        }

        function search(page) {
            $state.go('.', {
                page: page || 1,
                pageSize: vm.paging.itemsPerPage,
                identification: vm.model.search.identification,
                orderNumber: vm.model.search.orderNumber,
                barCode: vm.model.search.barCode,
                dateFrom: vm.model.search.dateFrom && (0, _moment2.default)(vm.model.search.dateFrom).format(vm.dateFormat),
                dateTo: vm.model.search.dateTo && (0, _moment2.default)(vm.model.search.dateTo).format(vm.dateFormat)
            });
        }

        function clear() {
            vm.model.search.identification = null;
            vm.model.search.orderNumber = null;
            vm.model.search.barCode = null;
            vm.model.search.dateFrom = null;
            vm.model.search.dateTo = null;

            search();
        }

        function goToPage(page) {
            if (page === 0 || page > vm.paging.pageCount) {
                return;
            }
            search(page);
        }

        function changeItemsPerPage(itemsPerPage) {
            vm.paging.itemsPerPage = itemsPerPage;
            search();
        }

        function isSearchUsed() {
            return !!$stateParams.identification && $stateParams.identification.length > 0 || !!$stateParams.orderNumber && $stateParams.orderNumber.length > 0 || !!$stateParams.barCode && $stateParams.barCode.length > 0 || !!$stateParams.dateFrom || !!$stateParams.dateTo;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/parcel-archive.js
// module id = 885
// module chunks = 0